import { HorizontalSection } from '@/components/display/horizontal-section';
import RestaurantCard from '@/components/display/restaurant-card';
import { useAppTheme } from '@/providers/theme-provider';
import { Restaurant } from '@/types/display';
import React from 'react';
import { ActivityIndicator, View } from 'react-native';

interface RestaurantSectionProps {
  title: string;
  restaurants: Restaurant[];
  isLoading: boolean;
  onSeeAll?: () => void;
}

export function RestaurantSection({ title, restaurants, isLoading, onSeeAll }: RestaurantSectionProps) {
  const theme = useAppTheme();

  if (!isLoading && restaurants.length === 0) return null;

  return (
    <HorizontalSection
      title={title}
      {...(onSeeAll ? { onActionPress: onSeeAll, actionText: 'See All' } : {})}
    >
      {isLoading ? (
        <View className="px-4 py-8 items-center">
          <ActivityIndicator size="small" color={theme.colors.primary} />
        </View>
      ) : (
        restaurants.map((restaurant) => (
          <RestaurantCard key={restaurant.id} restaurant={restaurant} />
        ))
      )}
    </HorizontalSection>
  );
}
